import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

export const ObjectPropertiesWrapper = ({ children, className, isForm, ...props }) => {
  return (
    <div
      className={classNames(
        "lg:tw-col-span-1 lg:tw-row-span-2 ac-border-radius-8 lg:tw-pt-6 tw-px-6 tw-pt-1",
        className,
        { "lg:tw-bg-theme-200": !isForm, "tw-pb-6 lg:tw-pb-0": isForm }
      )}
      {...props}
    >
      {children}
    </div>
  );
};

ObjectPropertiesWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isForm: PropTypes.bool,
};

ObjectPropertiesWrapper.defaultProps = {
  isForm: false,
};
